import { MeatballPanel } from 'app/area/search-filters/filters/meatball-panel';
import * as React from 'react';
import { Textarea } from 'ui';
import { FilterCommonProps } from './types';

export class FilterInput extends React.PureComponent<FilterCommonProps<string>> {

  private onChange = (value: string) => {
    const values = value !== '' && value.replace(/\s/g, '') === '' ? [] : [{ value }];
    this.props.onChange(this.props.id, values);
  };

  private currentValue = () => {
    const { values } = this.props;
    return values && values.length > 0 ? String(values[0].value) : undefined;
  };

  public render() {
    const { id, validation, meatballPanelConfiguration } = this.props;

    const currentValue = this.currentValue();

    return <>
      <MeatballPanel configuration={meatballPanelConfiguration} />
      <Textarea
        className={undefined}
        componentId={id}
        value={currentValue}
        onChange={this.onChange}
        maxLength={254}
        wait={0}
        validation={currentValue && validation}
      />
    </>;
  }
}
